import { render, staticRenderFns } from "./AddonSection.vue?vue&type=template&id=47530fab&scoped=true"
import script from "./AddonSection.vue?vue&type=script&lang=js"
export * from "./AddonSection.vue?vue&type=script&lang=js"
import style0 from "./AddonSection.vue?vue&type=style&index=0&id=47530fab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47530fab",
  null
  
)

export default component.exports